import React, { Component } from "react";

export default class ResetPass extends Component {
  validatePass = (firstPass, secondPass) => {
    const { updateErrors, userInfo, resetPassword } = this.props;
    let count = 0;
    let num = false;
    let lower = false;
    let upper = false;
    let len = false;
    let special = false;
    let match = false;

    if (!/\d/.test(firstPass)) {
      num = true;
      count++;
    }
    if (!/[a-z]/.test(firstPass)) {
      lower = true;
      count++;
    }
    if (!/[A-Z]/.test(firstPass)) {
      upper = true;
      count++;
    }
    if (firstPass.length < 8) {
      len = true;
      count++;
    }
    if (/^[a-zA-Z0-9- ]*$/.test(firstPass)) {
      special = true;
      count++;
    }
    if (firstPass !== secondPass) {
      match = true;
      count++;
    }

    updateErrors({
      num,
      lower,
      upper,
      len,
      special,
      match,
    });

    if (count > 0) {
      return;
    } else {
      resetPassword(firstPass, userInfo.get("token"));
    }
  };

  correctErrors = (value, firstPassword) => {
    const { userInfo } = this.props;

    let firstPass;
    let secondPass;
    if (firstPassword) {
      firstPass = value;
      secondPass = userInfo.get("secondPass");
    } else {
      firstPass = userInfo.get("firstPass");
      secondPass = value;
    }

    let num = userInfo.get("containsNumber");
    let upper = userInfo.get("containsUpperCaseLetter");
    let lower = userInfo.get("containsLowerCaseLetter");
    let len = userInfo.get("validLength");
    let special = userInfo.get("containsSpecialCharacter");
    let match = userInfo.get("passMatch");

    if (firstPass && secondPass) {
      if (num && /\d/.test(firstPass)) {
        num = false;
      }
      if (upper && /[A-Z]/.test(firstPass)) {
        upper = false;
      }
      if (lower && /[a-z]/.test(firstPass)) {
        lower = false;
      }
      if (len && firstPass.length >= 8) {
        len = false;
      }
      if (firstPass === secondPass) {
        match = false;
      }
      if (special && !/^[a-zA-Z0-9- ]*$/.test(firstPass)) {
        special = false;
      }
    }

    this.props.updateErrors({
      num,
      upper,
      lower,
      len,
      special,
      match,
    });
  };

  onFirstPassChange = (e) => {
    this.props.setFirstPass(e.target.value);
    this.correctErrors(e.target.value, true);
  };

  onSecondPassChange = (e) => {
    this.props.setSecondPass(e.target.value);
    this.correctErrors(e.target.value, false);
  };

  render() {
    const { userInfo } = this.props;
    return (
      <div className={userInfo.get("displayLoading") ? "hide" : ""}>
        <h1>Password Reset</h1>
        <p style={{ color: "black" }}>Passwords must:</p>
        <ul style={{ color: "black" }}>
          <li>Contain at least one lowercase letter.</li>
          <li>Contain at least one uppercase letter.</li>
          <li>Contain at least one number.</li>
          <li>
            Contain at one of these symbols <strong>@$!%*?&amp;</strong>.
          </li>
          <li>Be at least 8 characters long.</li>
          <li>
            NOT contain a <strong>#</strong>.
          </li>
        </ul>
        <form>
          <input
            placeholder="New Password"
            type="password"
            value={userInfo.get("firstPass")}
            onChange={this.onFirstPassChange}
            className="cc-input mar-b-10"
          />
          <input
            placeholder="Confirm New Password"
            type="password"
            value={userInfo.get("secondPass")}
            onChange={this.onSecondPassChange}
            className="cc-input mar-b-10"
          />
        </form>
        <ul className="error-list">
          <li
            className={
              userInfo.get("passMatch")
                ? "txt-warning animated fadeIn partner-specific-color"
                : "hide"
            }
          >
            Passwords don't match
          </li>
          <li
            className={
              userInfo.get("containsNumber")
                ? "txt-warning animated fadeIn partner-specific-color"
                : "hide"
            }
          >
            Password must require at least one number
          </li>
          <li
            className={
              userInfo.get("containsSpecialCharacter")
                ? "txt-warning animated fadeIn partner-specific-color"
                : "hide"
            }
          >
            Password must contain at least one of the following special
            characters: @$!%*?&
          </li>
          <li
            className={
              userInfo.get("containsUpperCaseLetter")
                ? "txt-warning animated fadeIn partner-specific-color"
                : "hide"
            }
          >
            Password must contain at least one uppercase letter
          </li>
          <li
            className={
              userInfo.get("containsLowerCaseLetter")
                ? "txt-warning animated fadeIn partner-specific-color"
                : "hide"
            }
          >
            Password must contain at least one lowercase letter
          </li>
          <li
            className={
              userInfo.get("validLength")
                ? "txt-warning animated fadeIn partner-specific-color"
                : "hide"
            }
          >
            Password must be at least eight characters
          </li>
        </ul>
        <button
          className="primary-cc-btn"
          onClick={() =>
            this.validatePass(
              userInfo.get("firstPass"),
              userInfo.get("secondPass")
            )
          }
        >
          Reset Password
        </button>
      </div>
    );
  }
}
